import React, { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MainContext from "./context/MainContext";
import { RouterProvider } from "react-router-dom";
import router from "./router/Routes";
import { useTranslation } from "react-i18next";
import ChatSupport from "./pages/ChatSuport";
import theme from "src/theme";
import { useMediaQuery } from "@mui/material";
import moment from "moment";
import "moment/locale/es";
import "moment/locale/ru";
import "moment/locale/uk";
import "moment/locale/tr";
import "moment/locale/th";
import { Agentation } from "agentation";
import { isPublicFormsPath } from "./utils/publicFormsPath";

// Importing locale files registers them and makes the LAST one ('tr') the
// active default — without this, dates render in Turkish even for English UIs.
moment.locale("en");

const App = () => {
  const context = useContext(MainContext);
  const { i18n } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const authenticated = context?.authenticated;
  const setAuthenticated = context?.setAuthenticated;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      if (setAuthenticated) {
        setAuthenticated(true);
      }
    }
    setLoading(false);
  }, [authenticated, setAuthenticated]);

  // GZ#2972: do NOT reload on orientationchange. A blanket
  // window.location.reload() here (since 30f88bf6, 2024-06) hard-reset the
  // whole SPA on every phone rotation — nothing persists MainProvider state,
  // so the admin calendar snapped back to the first location + today (Padel
  // Arena lost Wertheim/Heuchelhof + the picked date mid-work). React and
  // MUI's useMediaQuery re-render on viewport changes by themselves; a
  // rotation must keep the current screen's state.

  const Lang: number = Number(window.localStorage.getItem("Lng")) || 1;
  useEffect(() => {
    const loclang = Lang == 1 ? "en" : Lang == 2 ? "es" : Lang === 3 ? "ru" : Lang === 4 ? "uk" : Lang === 6 ? "th" : "tr";
    i18n.changeLanguage(loclang);
    moment.locale(loclang);
  }, [Lang]);

  if (loading) {
    return <div>Loading..</div>;
  }

  return (
    <>
      {process.env.NODE_ENV === 'development' && !isPublicFormsPath(window.location.pathname) && <Agentation />}
      <Grid container>
        {/*
          v7_startTransition wraps router navigations in React.startTransition.
          Every route element shares the identical
          <ChunkErrorBoundary><Suspense fallback={<Loading/>}> wrapper, so React
          reconciles them as the SAME Suspense fiber across navigations rather than
          remounting it. Navigating to a not-yet-loaded lazy page (e.g. CalenderPage)
          then re-suspends that already-revealed boundary during a synchronous update,
          which React 18 reports as error #426 ("a component suspended while responding
          to synchronous input"). Marking navigations as transitions keeps the previous
          page visible while the next chunk loads instead of throwing.
        */}
        <RouterProvider router={router} future={{ v7_startTransition: true }} />
        {/* No support chat on the public Forms pages: visitors are not club staff. */}
        {(process.env.REACT_APP_BACKEND_URL?.includes("dev") && !isMobile) || isPublicFormsPath(window.location.pathname) ? null : (
          <ChatSupport hideLauncher={true} />
        )}
      </Grid>
    </>
  );
};

export default App;
